module.exports = __webpack_public_path__ + "static/media/odoo_logo.bae69d5e.svg";